<template>
<div v-if="filteredCategories.length > 0">
  <button
      class="navbar-toggler pb-md-2 pb-4 pt-2 toggle-sl-button d-block d-sm-block d-lg-none ml-md-0 ml-2"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
      ref="navbarToggler"
  >
  </button>


  <nav class="navbar navbar-expand-lg navbar-light pl-md-0 pl-4 pt-0 sl-navbar  justify-content-lg-start all-platform-categories-container">
    <div class="w-100">

      <div class="collapse navbar-collapse" id="navbarNav">

        <ul class="nav nav-tabs d-block border-0 w-100">
          <li v-for="category in filteredCategories" :key="category.id">
            <div class="row mx-0 justify-content-center justify-content-md-start mb-3">
              <div class="categories-options text-padding"
                   :class="category.isSelected ? 'solution-sidenav-link' : null"
                   @click="updatePlatformCategory(category)">
                {{category.name}}
                {{`(${category.count})`}}
              </div>
            </div>
           
          </li>
        </ul>

      </div>
    </div>
  </nav>

</div>
</template>

<script>
import {mapGetters} from "vuex";
import CONSTANTS from "@/store/constants";
export default {
  name: "AllPlatformCategories",
  data(){
    return{
      SUPPLIER_REQUESTS_CATEGORIES: [
        {
          name: "All",
          tab: CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.ALL_REQUESTS,
          id: 1,
          isSelected : false,
          count : 0
        },
        {
          name: "Draft requests",
          tab: CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.DRAFT_REQUESTS,
          id: 2,
          isSelected : false,
          count : 0
        },
        {
          name: "Returned requests",
          tab: CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.RETURNED_REQUESTS,
          id : 3,
          isSelected : false,
          count : 0
        },
        {
          name: "Recently submitted requests",
          tab: CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.RECENTLY_SUBMITTED_REQUESTS,
          id: 4,
          isSelected : false,
          count: 0
        },
        {
          name: "Completed requests",
          tab: CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.COMPLETED_REQUESTS,
          id: 5,
          isSelected : false,
          count: 0
        }
      ]
    }
  },
  computed:{
    ...mapGetters(['supplierDraftData','onBoardingPendingRequests','onBoardingCompletedRequests','onBoardingReturnedRequests']),
    countTotalSupplierTabRecords(){
      return this.supplierDraftData.length + this.onBoardingReturnedRequests.length + this.onBoardingPendingRequests.length + this.onBoardingCompletedRequests.length
    },
    filteredCategories(){
      let filteredCategories = []

      if ((this.$route.fullPath.includes("status-dashboard") || this.$route.params.supplierRequestCategory === CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.ALL_REQUESTS) && this.countTotalSupplierTabRecords > 0){
        filteredCategories.push({...this.SUPPLIER_REQUESTS_CATEGORIES.find(category => category.id === 1),count: this.countTotalSupplierTabRecords,isSelected : true})

        if (this.supplierDraftData.length > 0){
            this.configureFilteredCategories(filteredCategories,2,this.supplierDraftData.length,false,this.$route.params.supplierRequestCategory,CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.DRAFT_REQUESTS)
        }
        if (this.onBoardingReturnedRequests.length > 0){
          this.configureFilteredCategories(filteredCategories,3,this.onBoardingReturnedRequests.length,false,this.$route.params.supplierRequestCategory,CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.RETURNED_REQUESTS)
        }
        if (this.onBoardingPendingRequests.length > 0 ){
          this.configureFilteredCategories(filteredCategories,4,this.onBoardingPendingRequests.length,false,this.$route.params.supplierRequestCategory,CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.RECENTLY_SUBMITTED_REQUESTS)
        }
        if (this.onBoardingCompletedRequests.length > 0){
          this.configureFilteredCategories(filteredCategories,5,this.onBoardingCompletedRequests.length,false,this.$route.params.supplierRequestCategory,CONSTANTS.MY_SUPPLIER_REQUESTS_TAB_ROUTES.COMPLETED_REQUESTS)
        }
      }
      return filteredCategories
    }
  },
  methods: {
    updatePlatformCategory(category) {
        /* eslint-disable no-console */
        this.$router.replace({name: 'SupplierRequestCategory', params: { supplierRequestCategory: category.tab } })
            .catch((ex) => {
              if (ex.name !== 'NavigationDuplicated') {
                console.error(ex)
              }
            });
        this.$emit("onSupplierRequestCategorySelected", category)
    },
    configureFilteredCategories(filteredCategories , categoryId , count , isSelected , route , tabRoute){
      filteredCategories.push({...this.SUPPLIER_REQUESTS_CATEGORIES.find(category => category.id === categoryId) ,count :count , isSelected: isSelected })
      if (route === tabRoute) {
        this.toggleCategory(filteredCategories,categoryId)
      }
    },
    toggleCategory(filteredCategories,categoryId) {
      filteredCategories.forEach(category => {
        category.isSelected = false
      })
      let category  = filteredCategories.find(category => category.id === categoryId)
      category.isSelected = true
    }
  },
}
</script>

<style scoped>
.text-padding {
  padding-left: 10px;
}

@media screen and (max-width: 576px) {
  .text-padding {
    padding-left: 0px;
  }
}

.categories-options {
  cursor: pointer;
  font-weight: 700;
}

hr {
  margin-top: 0.85rem;
  margin-bottom: 0.85rem;
}
</style>